export default function pbxReducer(pbx, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "partnerId":
      return { ...pbx, [action.type]: action.value, partner: { id: action.value } };
    case "defaultCountryCallingCode":
      return { ...pbx, [action.type]: Number(action.value.replace("+", "")) };

    default:
      return { ...pbx, [action.type]: action.value };
  }
}
